/* eslint-disable consistent-return */
import fetch from 'isomorphic-unfetch';
import config from '../../config';

const { apiHost } = config;

// load types from api
export const fetchTypes = () => async (dispatch) => {
    dispatch({ type: 'CORE_UI:FETCH_TYPES' });
    try {
        return await fetch(`${apiHost}/v1/types/all`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    dispatch({ type: 'CORE_UI:FETCH_TYPES_FAILURE', data: data.error });
                } else {
                    dispatch({ type: 'CORE_UI:FETCH_TYPES_SUCCESS', data });
                }
            });
    } catch (error) {
        dispatch({ type: 'CORE_UI:FETCH_TYPES_SUCCESS' });
    }
};

export const fetchSearchTypes = () => async (dispatch) => {
    dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES' });
    try {
        return await fetch(`${apiHost}/v1/types/search`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES_FAILURE', data: data.error });
                } else {
                    dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES_SUCCESS', data });
                }
            });
    } catch (error) {
        dispatch({ type: 'CORE_UI:FETCH_SEARCH_TYPES_SUCCESS' });
    }
};
